import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize } from '@fortawesome/free-regular-svg-icons';
import { MantineProvider, Global, Grid, Tabs, ScrollArea, Center, ActionIcon } from '@mantine/core';
import { useMediaQuery, useFullscreen } from '@mantine/hooks';
import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import useStyles, { useSubStyles } from './WarzonePanel.styles.js';
import { WarzonePanelLoader } from './WarzonePanelLoader.js';
import { WarzoneSelectedItemPanel } from './WarzoneSelectedItemPanel.js';
import { WarzoneMap } from '../map/WarzoneMap.js';
import { WarzoneTable } from '../table/WarzoneTable.js';
import { useWarzoneMap } from '../context/warzone-map.js';
import { useWarzoneStatus } from '../context/warzone-status.js';
var WarzonePanel = function WarzonePanel(_ref) {
  var classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    _ref$LoaderComponent = _ref.LoaderComponent,
    LoaderComponent = _ref$LoaderComponent === void 0 ? WarzonePanelLoader : _ref$LoaderComponent,
    _ref$initialScale = _ref.initialScale,
    initialScale = _ref$initialScale === void 0 ? 0.55 : _ref$initialScale,
    _ref$namesVisibleScal = _ref.namesVisibleScale,
    namesVisibleScale = _ref$namesVisibleScal === void 0 ? 0.5 : _ref$namesVisibleScal,
    _ref$maxScale = _ref.maxScale,
    maxScale = _ref$maxScale === void 0 ? 1 : _ref$maxScale,
    _ref$minScale = _ref.minScale,
    minScale = _ref$minScale === void 0 ? 0.35 : _ref$minScale,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 4 : _ref$columns,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? "#171B1C88" : _ref$backgroundColor,
    _ref$headerBackground = _ref.headerBackgroundColor,
    headerBackgroundColor = _ref$headerBackground === void 0 ? "#0E0E0E" : _ref$headerBackground,
    _ref$sidebarBackgroun = _ref.sidebarBackgroundColor,
    sidebarBackgroundColor = _ref$sidebarBackgroun === void 0 ? "#181818" : _ref$sidebarBackgroun,
    _ref$mapBackgroundCol = _ref.mapBackgroundColor,
    mapBackgroundColor = _ref$mapBackgroundCol === void 0 ? "transparent" : _ref$mapBackgroundCol,
    _ref$maskBackgroundCo = _ref.maskBackgroundColor,
    maskBackgroundColor = _ref$maskBackgroundCo === void 0 ? "#171B1C88" : _ref$maskBackgroundCo,
    blur = _ref.blur,
    factionTheme = _ref.factionTheme,
    tableSelectMode = _ref.tableSelectMode,
    _ref$allowDeselect = _ref.allowDeselect,
    allowDeselect = _ref$allowDeselect === void 0 ? false : _ref$allowDeselect,
    _ref$allowSelect = _ref.allowSelect,
    allowSelect = _ref$allowSelect === void 0 ? true : _ref$allowSelect,
    _ref$allowFullscreen = _ref.allowFullscreen,
    allowFullscreen = _ref$allowFullscreen === void 0 ? true : _ref$allowFullscreen,
    onClick = _ref.onClick,
    onClickOutside = _ref.onClickOutside,
    children = _ref.children;
  var _useStyles = useStyles({
      backgroundColor: backgroundColor,
      sidebarBackgroundColor: sidebarBackgroundColor,
      blur: blur
    }, {
      name: "WarzonePanel",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useSubStyles = useSubStyles({
      backgroundColor: backgroundColor,
      sidebarBackgroundColor: sidebarBackgroundColor,
      blur: blur
    }),
    tabsStyles = _useSubStyles.tabsStyles,
    scrollAreaStyles = _useSubStyles.scrollAreaStyles;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useWarzoneMap = useWarzoneMap(),
    dataLoading = _useWarzoneMap.loading;
  var _useWarzoneStatus = useWarzoneStatus(),
    statusLoading = _useWarzoneStatus.loading;
  var matches = useMediaQuery("(min-width: 1200px)");
  var _useState = useState("map"),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useFullscreen = useFullscreen(),
    ref = _useFullscreen.ref,
    toggle = _useFullscreen.toggle,
    fullscreen = _useFullscreen.fullscreen;
  useEffect(function () {
    setActiveTab(function (tab) {
      var mapIsActive = tab === "map";
      if (matches !== mapIsActive) {
        return matches ? "map" : "table";
      }
      return tab;
    });
  }, [matches]);
  var _useState3 = useState(initialScale > namesVisibleScale),
    _useState4 = _slicedToArray(_useState3, 2),
    namesVisible = _useState4[0],
    setNamesVisible = _useState4[1];
  var onZoomHandler = useCallback(function (_ref2) {
    var state = _ref2.state;
    setNamesVisible(state.scale >= namesVisibleScale);
  }, [namesVisibleScale]);
  return dataLoading || statusLoading ? /* @__PURE__ */jsx(LoaderComponent, {
    backgroundColor: maskBackgroundColor
  }) : /* @__PURE__ */jsxs(MantineProvider, {
    theme: {
      colorScheme: "dark",
      fontFamily: "Shentox, Rogan, sans-serif"
    },
    children: [/* @__PURE__ */jsx(Global, {
      styles: function styles() {
        return {
          body: {
            fontFamily: "Shentox, Rogan, sans-serif"
          }
        };
      }
    }), /* @__PURE__ */jsxs(Grid, {
      columns: columns,
      gutter: 0,
      className: cx(classes.root, factionTheme ? classes[factionTheme] : ""),
      ref: ref,
      children: [/* @__PURE__ */jsx(Grid.Col, {
        span: columns,
        lg: columns - 1,
        order: 2,
        orderLg: 1,
        className: classes.contentCell,
        children: /* @__PURE__ */jsxs(Tabs, {
          keepMounted: true,
          styles: tabsStyles,
          value: activeTab,
          onTabChange: setActiveTab,
          defaultValue: matches ? "map" : "table",
          children: [/* @__PURE__ */jsxs(Tabs.List, {
            children: [matches ? /* @__PURE__ */jsx(Tabs.Tab, {
              value: "map",
              children: t("warzone.tab.map")
            }) : /* @__PURE__ */jsx(Fragment, {}), /* @__PURE__ */jsx(Tabs.Tab, {
              value: "table",
              children: t("warzone.tab.table")
            })]
          }), matches ? /* @__PURE__ */jsx(Tabs.Panel, {
            value: "map",
            children: /* @__PURE__ */jsx(TransformWrapper, {
              initialScale: initialScale,
              centerOnInit: true,
              maxScale: maxScale,
              minScale: minScale,
              onZoom: onZoomHandler,
              zoomAnimation: {
                disabled: true
              },
              alignmentAnimation: {
                disabled: true
              },
              children: /* @__PURE__ */jsx("div", {
                className: classes.inner,
                children: /* @__PURE__ */jsx(TransformComponent, {
                  wrapperStyle: {
                    maxWidth: "100%",
                    maxHeight: "100%"
                  },
                  contentStyle: {
                    willChange: "transform"
                  },
                  children: /* @__PURE__ */jsx(WarzoneMap, {
                    maskBackgroundColor: maskBackgroundColor,
                    backgroundColor: mapBackgroundColor,
                    showSystemNames: namesVisible,
                    onClick: onClick,
                    onClickOutside: onClickOutside,
                    allowSelect: allowSelect,
                    allowDeselect: allowDeselect
                  })
                })
              })
            })
          }) : "", /* @__PURE__ */jsx(Tabs.Panel, {
            value: "table",
            children: /* @__PURE__ */jsx("div", {
              className: classes.inner,
              children: /* @__PURE__ */jsx(ScrollArea, {
                className: classes.tableDataOuter,
                type: "auto",
                offsetScrollbars: true,
                scrollbarSize: 12,
                styles: scrollAreaStyles,
                children: /* @__PURE__ */jsx(Center, {
                  className: classes.tableDataInner,
                  children: /* @__PURE__ */jsx(WarzoneTable, {
                    onClick: onClick,
                    selectMode: tableSelectMode,
                    headerBackgroundColor: headerBackgroundColor,
                    allowSelect: allowSelect
                  })
                })
              })
            })
          })]
        })
      }), /* @__PURE__ */jsxs(Grid.Col, {
        span: columns,
        lg: 1,
        order: 1,
        orderLg: 2,
        className: classes.infoCell,
        children: [(matches || fullscreen) && allowFullscreen && /* @__PURE__ */jsx(ActionIcon, {
          variant: "subtle",
          className: classes.fullScreenIcon,
          onClick: toggle,
          children: /* @__PURE__ */jsx(FontAwesomeIcon, {
            icon: faWindowMaximize
          })
        }), /* @__PURE__ */jsx(WarzoneSelectedItemPanel, {}), children]
      })]
    })]
  });
};
export { WarzonePanel };